@if (reportTemplates().length > 0) {
    <ng-container *transloco="let t">
        <dv-report-template-outdated-icon
            class="version-icon"
            [reportType]="reportType()"
            [reportTemplate]="selectedReportTemplate()"/>
        <select class="form-control"
                [(ngModel)]="selectedReportTemplate"
                [ngModelOptions]="{standalone: true}"
                [compareWith]="compareById"
                [isDisabled]="isDisabled()"
                (change)="templateChanged()"
                (blur)="onTouched?.()"
                [tooltip]="t('REPORT.TEMPLATE.TEMPLATE')"
                [attr.aria-label]="t('REPORT.TEMPLATE.TEMPLATE')">
            <option [ngValue]="undefined">{{ t('REPORT.TEMPLATE.DEFAULT') }}</option>
            @for (template of reportTemplates(); track template.id) {
                <option [ngValue]="template">{{ template.name }}</option>
            }
        </select>
    </ng-container>
}
